var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3030_22225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96109 12.3803C8.26848 7.25892 15.6615 5.60559 22.3152 7.41638L25.6381 4.0546C17.0467 0.803048 7 2.57448 0 9.38463L2.96109 12.3803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9986 11.9001C17.2866 11.9001 17.5706 11.9119 17.8585 11.9276L21.5239 8.21943C15.3332 6.72749 8.55504 8.3454 3.64453 13.0731L6.60173 16.0649C9.43052 13.3763 13.0998 11.9001 16.9986 11.9001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9038 12.8921C13.4447 12.9157 9.98945 14.2029 7.28906 16.7577L10.1879 19.6904L16.9077 12.8921H16.9038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 23.56C14.974 23.56 13.3242 25.2291 13.3242 27.28C13.3242 29.3309 14.974 31 17.0013 31C19.0285 31 20.6783 29.3309 20.6783 27.28C20.6783 25.2291 19.0285 23.56 17.0013 23.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 12.3803L34.0053 9.38463C32.2776 7.70375 30.3633 6.33384 28.336 5.26705L32.5695 0.984127L31.5967 0L4.35547 27.5556C4.42551 27.5831 5.32823 28.5397 5.32823 28.5397L12.1298 21.6587L13.8963 23.4458C15.694 21.9539 18.3049 21.9539 20.1064 23.4458L23.0675 20.4502C21.3983 18.9307 19.2621 18.1001 17.0014 18.1001C16.5033 18.1001 16.0092 18.1473 15.5267 18.226L16.6084 17.1317C16.7407 17.1277 16.8691 17.112 17.0014 17.112C19.5228 17.112 21.9041 18.045 23.7562 19.7495L26.7134 16.7577C24.8769 15.0178 22.6862 13.8683 20.3866 13.3015L21.1882 12.4905C23.4917 13.1558 25.6123 14.3683 27.3944 16.0649L30.3516 13.0731C28.5889 11.3765 26.5812 10.0853 24.4527 9.18781L25.192 8.43987C27.301 9.37676 29.2815 10.6876 31.0403 12.3803H31.0442Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3030_22225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiError);
export default __webpack_public_path__ + "static/media/wifi_error.8be5817039250b0654317010c7924852.svg";
export { ForwardRef as ReactComponent };